import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "@/ag-grid-overrides.css";
import App from "@/App";
import { AgGridProvider } from "ag-grid-react";
import {
  AllCommunityModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
} from "ag-grid-community";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AgGridProvider
      modules={[
        AllCommunityModule,
        ClientSideRowModelModule,
        ColumnAutoSizeModule,
      ]}
    >
      <App />
    </AgGridProvider>
  </React.StrictMode>,
);
